import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CouponInterface } from "../../models/order";
import { HttpBaseService } from "@gea-waldviertler-website/shop-lib";
import { CartSubmitInterface } from "../../models/cart";

@Injectable()
export class HttpCouponService extends HttpBaseService {
  getCoupon(code: string, cart: CartSubmitInterface) : Observable<CouponInterface> {
    const url: string = this.getMainApiBaseUrl() + "/order/check_voucher?code=" + code
    return this.http.post<CouponInterface>(url, cart)
  }
}
